module.exports = __webpack_public_path__ + "static/img/jobs_img2.6a0fa99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jobs_img2.png
// module id = p6IZ
// module chunks = 94